export const profile = {
  name: "Amol",
  role: "C# / .NET Team Lead",
  headline: "Building intelligent software systems.",
  location: "India",
  experience: "10+ YEARS",
  heroEyebrow: "C# / .NET TEAM LEAD",
  heroLines: ["BUILDING", "INTELLIGENT", "SOFTWARE", "SYSTEMS."],
  heroSub: "Software engineer focused on scalable .NET systems, AI-powered engineering tools, computer vision, automation, and enterprise software.",
  statement: ["I build software where", "engineering discipline meets", "practical intelligence."],
  about: "My work spans enterprise .NET applications, automation, computer vision, AI-assisted development, database systems, integrations, and technical leadership.",
  availability: "OPEN TO INTERESTING ENGINEERING PROBLEMS",
  heroFlow: "DATA → SYSTEMS → AI → DECISIONS",
};

export const navLinks = [
  { id: "work", label: "WORK" },
  { id: "about", label: "ABOUT" },
  { id: "experience", label: "EXPERIENCE" },
  { id: "lab", label: "LAB" },
  { id: "contact", label: "CONTACT" },
] as const;
